export default __webpack_public_path__ + "static/media/guest_7_2_mariana_luz.99fe02a2.png";